import firebase from 'firebase/app';
// Add the Firebase products that you want to use
import 'firebase/auth';
import 'firebase/firestore';

class FirebaseAuthBackend {
    private authReady: Promise<void> = Promise.resolve();

    constructor(firebaseConfig) {
        if (firebaseConfig) {
            // Initialize Firebase
            firebase.initializeApp(firebaseConfig);
            // Résolue au premier état d'auth connu (au rechargement, currentUser est null un court instant)
            this.authReady = new Promise<void>((resolve) => {
                const unsubscribe = firebase.auth().onAuthStateChanged(() => { unsubscribe(); resolve(); });
            });
            firebase.auth().onAuthStateChanged((user) => {
                let userDto : any = user;
                if (user) {
                    firebase.auth().currentUser.getIdTokenResult()
                    .then((idTokenResult) => {
                        // Confirm the user is an Admin.
                        if (idTokenResult.claims.role) {
                                userDto.role = idTokenResult.claims.role;
                                userDto.tenant = idTokenResult.claims.tenant;
                                sessionStorage.setItem('role', userDto.role);
                                sessionStorage.setItem('tenant', userDto.tenant);
                                
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });
                    sessionStorage.setItem('authUser', JSON.stringify(userDto));
                  
                } else {
                    sessionStorage.removeItem('authUser');
                    sessionStorage.removeItem('role');
                    sessionStorage.removeItem('tenant');
                }
            });
        }
    }

    /**
     * Registers the user with given details
     */
    registerUser = (email, password) => {
        return new Promise((resolve, reject) => {
            firebase.auth().createUserWithEmailAndPassword(email, password).then((user: any) => {
                var user: any = firebase.auth().currentUser;
                resolve(user);
            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * Login user with given details
     */
    loginUser = (email, password) => {
        return new Promise((resolve, reject) => {
            firebase.auth().signInWithEmailAndPassword(email, password).then((user: any) => {
                // eslint-disable-next-line no-redeclare
                var user: any = firebase.auth().currentUser;
                resolve(user);
            }, (error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * forget Password user with given details
     */
    forgetPassword = (email) => {
        return new Promise((resolve, reject) => {
            // tslint:disable-next-line: max-line-length
            firebase.auth().sendPasswordResetEmail(email, { url: window.location.protocol + '//' + window.location.host + '/account/login' }).then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    /**
     * Logout the user
     */
    logout = () => {
        return new Promise((resolve, reject) => {
            firebase.auth().signOut().then(() => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            });
        });
    }

    setLoggeedInUser = (user) => {
        sessionStorage.setItem('authUser', JSON.stringify(user));
    }

    /**
     * Jeton d'identité à jour : le SDK le renouvelle avant expiration (≈1 h).
     * L'instantané stocké dans sessionStorage, lui, n'est jamais rafraîchi.
     */
    /** Force un nouveau jeton (après une invitation acceptée) et met à jour rôle et ferme en session */
    rafraichirJeton = async (): Promise<any> => {
        await this.authReady;
        const user = firebase.auth().currentUser;
        if (!user) return null;
        await user.getIdToken(true);
        const r = await user.getIdTokenResult();
        if (r.claims.role) {
            sessionStorage.setItem('role', r.claims.role);
            sessionStorage.setItem('tenant', r.claims.tenant || '');
        }
        return r.claims;
    }

    /** Claims du jeton courant (rôle, ferme), null si déconnecté */
    claims = async (): Promise<any> => {
        await this.authReady;
        const user = firebase.auth().currentUser;
        return user ? (await user.getIdTokenResult()).claims : null;
    }

    nomAffiche = async (nom: string): Promise<void> => {
        const user = firebase.auth().currentUser;
        if (user && nom) await user.updateProfile({ displayName: nom });
    }

    getIdToken = async (): Promise<string | null> => {
        await this.authReady;
        const user = firebase.auth().currentUser;
        return user ? user.getIdToken() : null;
    }

    /**
     * Returns the authenticated user
     */
    getAuthenticatedUser = () => {
        if (!sessionStorage.getItem('authUser')) {
            return null;
        }

        let user =  JSON.parse(sessionStorage.getItem('authUser'));
        if(!user.role){
            user.role = sessionStorage.getItem('role');
        }

        user.tenant = sessionStorage.getItem('tenant');
        
        return user;
    }

    /**
     * Handle the error
     * @param {*} error
     */
    _handleError(error) {
        // Code Firebase conservé (auth/wrong-password…) : les écrans traduisent par code
        return { code: error?.code, message: error?.message };
    }
}

// tslint:disable-next-line: variable-name
let _fireBaseBackend = null;

/**
 * Initilize the backend
 * @param {*} config
 */
const initFirebaseBackend = (config) => {
    if (!_fireBaseBackend) {
        _fireBaseBackend = new FirebaseAuthBackend(config);
    }
    return _fireBaseBackend;
};

/**
 * Returns the firebase backend
 */
const getFirebaseBackend = () => {
    return _fireBaseBackend;
};

export { initFirebaseBackend, getFirebaseBackend };
